/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  credentials: {
    accessToken: null,
    refreshToken: null
  },
  data: {
    id: null,
    username: null,
    isAdmin: false
  }
}

const slice = createSlice({
  name: 'authCredentials',
  initialState,
  reducers: {
    loginSuccess: (state, { payload }) => {
      state.credentials = payload.credentials
      // state.data = payload.data
    },
    logout: (state) => {
      state.credentials = {
        accessToken: null,
        refreshToken: null
      }
    }
  }
})

// Actions
export const { loginSuccess, logout } = slice.actions

export default slice.reducer
